(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypePatientContactTypesController', TypePatientContactTypesController);

    TypePatientContactTypesController.$inject = ['TypePatientContactTypes', 'GenericEntityDatatableService',
        'CoreService', '$q', '$uibModal', 'ConfirmationService'];

    function TypePatientContactTypesController(TypePatientContactTypes, GenericEntityDatatableService,
                                               CoreService, $q, $uibModal, ConfirmationService) {
        var vm = this;

        var params = {
            id: CoreService.getCorporation().id
        }

        vm.descriptor = {
            title: 'Patient Contact Types',
            newButtonTitle: 'Patient Contact Type',
            entityClassHumanized: 'Patient Contact Types',
            entityStateName: 'type-patient-contact-types',
            service: TypePatientContactTypes,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Insurance Audit Config',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-contact-types/update/type-patient-contact-types-dialog.html',
                controller: 'TypePatientContactTypesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-contact-types/update/type-patient-contact-types-dialog.html',
                controller: 'TypePatientContactTypesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypePatientContactTypes', function (TypePatientContactTypes) {
                        return TypePatientContactTypes.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Patient Contact Types').result.then(function () {
                    TypePatientContactTypes.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
